import React, { Suspense } from 'react'
import { css } from '@emotion/core'
import { Switch, Route, NotFound, useRouteMatch } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import { appPath } from '@fs/zion-config'
import { useUser } from '@fs/zion-user'
import PageLoadingIndicator from '../../shared/components/PageLoadingIndicator'
import AAMMain from './components/AAMMain'
import AAMGuestMain from './components/AAMGuestMain'
import { AamProvider } from './state/AamStore'
import { useCorrections } from './hooks/hooks'
import ExperienceChrome from '../../shared/components/ExperienceChrome/ExperienceChrome'
import useLegacyNavHomePath from '../../shared/components/ExperienceNavControls/useLegacyNavHomePath'

// AAM has no top bar for the floating nav controls to share (its first row is
// the country button at the inline start, exactly where the controls float), so
// clear them the standard way: 0px whenever the controls render nothing.
const contentCss = css`
  padding-block-start: var(--experience-nav-clearance, 0px);
`

export default function AppAam({ nonstandardUser }) {
  const isCorrections = useCorrections()
  const user = useUser()
  // '/about', or '/about/un' when mounted by the un route - each is its own
  // landing, so each gets the Home control at its own base path.
  const { path } = useRouteMatch()
  const navHomePath = useLegacyNavHomePath(path)

  if (isCorrections && user?.signedIn) {
    // NOTE: This is a hacky solution to enforce a logout when the correctionslogin path is used. We tried a few other solutions and this was the only one we could get to work.
    window.location.href = `/auth/logout?returnUrl=${encodeURIComponent(window.location.href)}`
  } else if (isCorrections && !nonstandardUser?.initialized) {
    window.location.href = `${appPath}/about/correctionslogin`
  }

  const unAuthUser = nonstandardUser && !nonstandardUser?.authenticated && !user?.signedIn
  // eslint-disable-next-line react/no-unstable-nested-components
  const RenderAAMMain = () => (unAuthUser ? <AAMGuestMain nonstandardUser={nonstandardUser} /> : <AAMMain />)

  return (
    <ErrorBoundary>
      <ExperienceChrome activeExperienceId="aam" navHomePath={navHomePath} />
      <div tabIndex="-1" css={contentCss}>
        <AamProvider>
          <Suspense fallback={<PageLoadingIndicator />}>
            <Switch>
              <Route path={path} render={RenderAAMMain} requirePersonalData />
              <Route render={NotFound} requirePersonalData />
            </Switch>
          </Suspense>
        </AamProvider>
      </div>
    </ErrorBoundary>
  )
}
